import { account } from '@/utils/api/account';
import { affiliates } from '@/utils/api/affiliates';
import { ai } from '@/utils/api/ai';
import { billing } from '@/utils/api/billing';
import { csv } from '@/utils/api/csv';
import { listings } from '@/utils/api/listings';
import { merge } from '@/utils/api/merge';
import { photoEditor } from '@/utils/api/photoEditor';
import { products } from '@/utils/api/products';
import { profiles } from '@/utils/api/profiles';
import { request } from '@/utils/api/request';
import { schedule } from '@/utils/api/schedule';
import { shops } from '@/utils/api/shops';
import { studio } from '@/utils/api/studio';
import { user } from '@/utils/api/user';
import { variations } from '@/utils/api/variations';
import { waitlist } from '@/utils/api/waitlist';

export const api = {
  ...request,
  account,
  affiliates,
  ai,
  billing,
  csv,
  listings,
  merge,
  photoEditor,
  products,
  profiles,
  schedule,
  shops,
  studio,
  user,
  variations,
  waitlist,
};
